import { Component, OnInit, ViewChild } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { AlertService } from "src/app/services/alert.service";
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import { UtilityService } from "../../services/utility.service";

@Component({
  selector: "app-signup",
  templateUrl: "./signup.component.html",
  styleUrls: ["./signup.component.css"],
})
export class SignupComponent implements OnInit {
  @ViewChild("signupform") public signupform: NgForm;
  model: any = {};
  step: number = 0;
  hide: boolean = true;
  countries: any = [];
  states: any = [];
  constructor(
    private utilityService: UtilityService,
    private authService: AuthService,
    private alertService: AlertService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getCountriesList();
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }
  //register User
  register() {
    if (!this.signupform.valid) {
      return;
    }
    this.authService.register(this.model).subscribe(
      (res: any) => {
        if (!res.error) {
          this.alertService.updateAlert("Registered Successfully");
          this.router.navigate(["/login"]);
        } else {
          this.alertService.updateAlert(res.errorMessage);
        }
      },
      (error) => {},
      () => {

      }
    );
  }
  /**
   * Get list of countries
   */
  getCountriesList() {
    this.utilityService.getCountriesList().subscribe((res: any) => {
      if (!res.error) {
        this.countries = res.response;
      }
    });
  }
  /**
   * Get list of states of selected country
   * @param countryID
   */
  getStatesList(countryID) {
    this.utilityService.getStatesList(countryID).subscribe((res: any) => {
      if (!res.error) {
        this.states = res.response;
      }
    });
  }
  /**
   * Reset the states field when country is changed
   * @param stateReference
   */
  resetStates(stateReference) {
    stateReference.control.reset();
    this.states = [];
  }
}
